import { render, staticRenderFns } from "./Drawlot.vue?vue&type=template&id=ddb974e6&scoped=true&"
import script from "./Drawlot.vue?vue&type=script&lang=js&"
export * from "./Drawlot.vue?vue&type=script&lang=js&"
import style0 from "./Drawlot.vue?vue&type=style&index=0&id=ddb974e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb974e6",
  null
  
)

export default component.exports